export default __webpack_public_path__ + "static/media/logo-integrity.7cd5d788.svg";